import React from 'react';
import styles from './index.scss';
import Icon from '@xo-union/tk-component-icons';
import { Button } from '@xo-union/tk-component-buttons';

interface ModalErrorMessageProps {
  errorMessage?: string;
  onRetry?: () => void;
}
export const ModalErrorMessage: React.FC<ModalErrorMessageProps> = ({ errorMessage, onRetry }) => {
  return (
    <div className={styles.errorMessageContainer}>
      <Icon style={{ color: '#EB1400' }} size="md" name="warning" />{' '}
      <div className={styles.errorMessage}>
        {errorMessage || 'There was an issue generating the text. Please try again.'}

        {onRetry && (
          <Button size="md" color="primary-alternative" onClick={onRetry}>
            Try Again
          </Button>
        )}
      </div>
    </div>
  );
};
